const smallCategories = () => {

    let smallCategoriesLink = document.querySelectorAll('.small-categories__link');

    if (smallCategoriesLink.length > 2) {
        for (let i = 1; i < smallCategoriesLink.length; i++) {
            smallCategoriesLink[i].onmouseover = () => {
                let img = document.querySelector('.small-categories__img');
                img.style.opacity = "0";
            }

            smallCategoriesLink[i].onmouseout = () => {
                let img = document.querySelector('.small-categories__img');
                img.style.opacity = "1";
            }     
        }
    }
    
    
    
}
export default smallCategories;